import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form as SemanticForm } from 'semantic-ui-react';
import { Field, Formik } from 'formik';
import { InputFormField, IfScope } from '@playbookux/playbook-web-core';
import Condition from './condition';
import {
  Header,
  FormRow,
  ConditionContainer,
  ErrorMessage,
  Checkbox,
} from './styles';

const NewFilterTab = ({
  conditions,
  handleConditionChange,
  addCondition,
  removeCondition,
  filterOptions,
  onSubmit,
  error,
  attributeOptions,
  allQuestions,
  scope,
  setSubmitForm,
}) => {
  const [savedCounts, setSavedCounts] = useState({});

  return (
    <Formik
      initialValues={{
        name: 'Untitled filter',
        saveFilter: true,
      }}
      onSubmit={onSubmit}
    >
      {({
        errors,
        setFieldValue,
        handleSubmit,
        values,
      }) => {
        setSubmitForm(handleSubmit);

        return (
          <SemanticForm onSubmit={handleSubmit}>
            <Header as="h4">Name this filter</Header>
            <FormRow>
              <Field
                name="name"
                error={errors.name}
                component={InputFormField}
              />
              <IfScope user scope={scope}>
                <Checkbox
                  label="Save this filter"
                  name="saveFilter"
                  checked={values.saveFilter}
                  onChange={({ checked }) => setFieldValue('saveFilter', checked)}
                />
              </IfScope>
            </FormRow>

            <ConditionContainer>
              <Header as="h4">Create a new filter</Header>
              {conditions.map((condition, index) => (
                <Condition
                  key={condition.id}
                  condition={condition}
                  index={index}
                  conditionsLength={conditions.length}
                  handleConditionChange={handleConditionChange}
                  addCondition={addCondition}
                  removeCondition={removeCondition}
                  filterOptions={filterOptions}
                  attributeOptions={attributeOptions}
                  allQuestions={allQuestions}
                  savedCounts={savedCounts}
                  setSavedCounts={setSavedCounts}
                />
              ))}
            </ConditionContainer>

            {error && <ErrorMessage>One or more values is blank</ErrorMessage>}
          </SemanticForm>
        );
      }}
    </Formik>
  );
};

NewFilterTab.propTypes = {
  conditions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      attribute: PropTypes.string.isRequired,
      operator: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string),
      ]),
    }),
  ).isRequired,
  handleConditionChange: PropTypes.func.isRequired,
  addCondition: PropTypes.func.isRequired,
  removeCondition: PropTypes.func.isRequired,
  filterOptions: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  error: PropTypes.bool.isRequired,
  attributeOptions: PropTypes.array.isRequired,
  allQuestions: PropTypes.array.isRequired,
  scope: PropTypes.string.isRequired,
  setSubmitForm: PropTypes.func.isRequired,
};

export default NewFilterTab;
